var _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    id: "Crystal_x5F_Shard",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#5B153E",
    points: "286.189,10.023 197.834,96.197 161.838,233.639 216.378,455.071 293.825,501.977 308.006,451.799   337.457,139.829 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "SVGID_1_",
    x1: 352.6113,
    x2: 198.4708,
    y1: 409.2539,
    y2: 40.8847
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CC5697"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E585BE"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_1_)",
    points: "337.457,139.829 282.917,80.926 207.651,185.643 293.825,501.977 308.006,451.8 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#F49FD3",
    points: "337.457,139.829 337.457,139.829 286.189,10.023 282.917,80.926 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#A03774",
    points: "282.917,80.926 286.189,10.023 197.834,96.197 207.651,185.643 "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#A03774",
    points: "207.651,185.643 216.378,455.071 293.825,501.977 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M135.817,47.732c0,0,2.546,24.612-17.54,35.928c0,0,20.086,6.602,21.218,30.459  c0,0,0.849-27.347,16.407-35.551C155.902,78.568,138.363,71.496,135.817,47.732z",
    fill: "#FFE9FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M373.637,222.807c0,0,2.547,24.611-17.539,35.928c0,0,20.086,6.602,21.217,30.459  c0,0,0.849-27.347,16.408-35.551C393.723,253.643,376.184,246.57,373.637,222.807z",
    fill: "#FFE9FB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M154.63,356.787c0,0,2.546,24.612-17.54,35.929c0,0,20.086,6.602,21.218,30.459  c0,0,0.849-27.347,16.408-35.551C174.716,387.624,157.176,380.551,154.63,356.787z",
    fill: "#FFE9FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.16e152ea4cb51073af81924f2daf89d3.svg";
export { ForwardRef as ReactComponent };